import { Box, Button, Dialog, DialogContent, Paper, Typography } from "@mui/material";
import { initPageData, jobOrderApiNm, jobOrderColNm } from 'constants/jobOrderConstant';
import { blueGrey } from "@mui/material/colors";
import { BoxFC, BoxFR } from "components/BoxCustom";
import PaperComponent from "components/PaperComponent";
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import ContStatus from "./DailyJobDialogV2Component/ContStatus";
import Shipment from "./DailyJobDialogV2Component/Shipment";
import Shore from "./DailyJobDialogV2Component/Shore";
import Memo from "./DailyJobDialogV2Component/Memo";
import dayjs from "dayjs";
import { printJobOrder } from "branch/functions/printJobOrder";
import { UserContext } from "contexts/UserContext";
import ButtonGroupPopper from "components/ButtonGroupPopper";
import { alertConfirmDelete, alertError } from "components/Alert";
import LogTableDialog from "components/LogTableDialog/LogTableDialog";
import LogViewDialog from "components/LogViewDialog/LogViewDialog";
import { checkContStatus } from "./DailyJobDialogV2Component/checkContStatus";
import { addIdForDataGrid } from "utils";
import XJOComponent from "./DailyJobDialogV4Component/XJOComponent";
import PCComponent from "./DailyJobDialogV4Component/PCComponent";
import ContStsComponent from "./DailyJobDialogV4Component/ContStsComponent";
import JODataComponent from "./DailyJobDialogV4Component/JODataComponent";
import FilePreviewComponent from "./DailyJobDialogV4Component/FilePreviewComponent";
import JODataExtraComponent from "./DailyJobDialogV4Component/JODataExtraComponent";
import { HistoryRounded } from "resource/muiImport";
// import PettyCash from "./DailyJobDialogV2Component/PettyCash";
const jocsHistoryColumns = ["ContStsNm", "StsTm", "IsCmpt", "DrvNNm", "TukCd"]
const jocsHistoryColumnsWidth = { StsTm: 140 }
const jocsHistoryDatetimeFormat = { StsTm: "YYYY-MM-DD HH:mm" }

const excludeKeys = ["JobOrdLogId", "JobOrdId", "ModDte", "ModAcc"]

const DailyJobDialogV3 = ({ selectedId, dialogOpen, setDialogOpen, lastFilter, onFinish }) => {

  const { ax, msData, setTargetTimestamp } = useContext(GlobalStateContext)
  const { user } = useContext(UserContext)
  const prevContStsDataRef = useRef([])
  const oContStatusDataRef = useRef([])
  const oJODataRef = useRef({})
  const oTagDataRef = useRef([])
  const oMemoDataRef = useRef([])

  const [contStatusData, setContStsData] = useState([])
  const [joData, setJOData] = useState({ ...initPageData })
  const [tagData, setTagData] = useState([])
  const [memoData, setMemoData] = useState([])
  const [ptDataTable, setPTDataTable] = useState([])
  const [piDataTable, setPIDataTable] = useState([])
  const [xjoDataTable, setXJODataTable] = useState([])
  const [filesData, setFilesData] = useState([])
  const [dialogHistoryOpen, setDialogHistoryOpen] = useState(false)
  const [dialogCSHistoryOpen, setDialogCSHistoryOpen] = useState(false)

  const jocsHistoryPostData = useMemo(() => (
    { TableNm: "job_order_container_status_log", IdColNm: "JobOrdId", IdValue: selectedId })
    , [selectedId])
  const deleteJobOrder = useCallback((jobOrdId) => {
    alertConfirmDelete(() => {
      ax.post(jobOrderApiNm.deleteJobOrder, { JobOrdId: jobOrdId }).then(value => {
        if (value.data) {
          // processConstStatus(value.data, msData)
          //setDataTable(addIdForDataGrid(value.data, "JobOrdId"));
          setDialogOpen(false);
          setTargetTimestamp(dayjs())
          onFinish()
        }
      })
    })
  }, [ax, setTargetTimestamp, onFinish, setDialogOpen])

  const handleDialogOK = useCallback(async () => {
    //set joData back to init data

    if (!joData.AptTm) {
      alertError("วันที่นัดส่ง ต้องไม่เป็นค่าว่าง")
      return
    }



    const contStsHasChange = JSON.stringify(oContStatusDataRef.current) !== JSON.stringify(contStatusData)
    const tagDataHasChange = JSON.stringify(oTagDataRef.current) !== JSON.stringify(tagData)
    const joDataHasChange = JSON.stringify(oJODataRef.current) !== JSON.stringify(joData)
    const memoDataHasChange = JSON.stringify(oMemoDataRef.current) !== JSON.stringify(memoData)
    let ptDataHasChange = false


    const postData = {
      getArgs: lastFilter
    }

    const foundPCTrns = ptDataTable.filter(pt => pt.TmpUsrAccId)
    if (joData.processDrvId && foundPCTrns.length > 0) {
      ptDataHasChange = true
      postData.ptData = {
        UsrAccId: joData.processDrvId,
        PCTrnsIds: foundPCTrns.map(pt => pt.PCTrnsId)
      }
    }

    joData.processDrvId = null

    if (contStsHasChange) {
      postData.contStatusData = contStatusData
    }

    if (tagDataHasChange) {
      // await ax.post(jobOrderApiNm.updateJobOrderTag, { JobOrdIds: [selectedId], TagIds: tagData.map(tag => tag.id) })
      postData.tagData = { JobOrdIds: [selectedId], TagIds: tagData.map(tag => tag.id) }
    }

    const joColValue = {}
    const swpContStsData = []
    let swpJobOrdIdHasChange = false
    if (joDataHasChange) {
      for (const key in joData) {
        if (["SwpContNo", "SwpJobOrdIdPrev", "SwpContNoPrev"].includes(key)) {
          continue
        }
        if (oJODataRef.current[key] !== joData[key]) {
          if (["SwpJobOrdId"].includes(key) ) {
            if(!joData[key]){
              joColValue[key] = null
            } else {
              joColValue[key] = joData[key]
            }
            swpJobOrdIdHasChange = true
          } else if (["SwpDrvIdSts4", "SwpDrvIdSts5"].includes(key)) {
            let contStsId = null

            if (key === "SwpDrvIdSts4") {
              contStsId = 4
            } else if (key === "SwpDrvIdSts5") {
              contStsId = 5
            }
            if (!contStsId) continue

            swpContStsData.push({ ContStsId: contStsId, DrvId: joData[key], TukId: msData.driverObj[joData[key]]?.TukId })
          } else {
            joColValue[key] = joData[key]
          }
        }
      }
      postData.jobOrdData = {
        JobOrdId: joData.JobOrdId,
        ColValues: joColValue,
        LogRmk: "แก้ไขข้อมูลใบงาน"
      }
      if(swpContStsData.length === 0){
        postData.swpContStsData = null
      } else {
        postData.swpContStsData = swpContStsData
      }
      if(postData.swpContStsData && !swpJobOrdIdHasChange){
        alertError("กรุณากรอกเลขที่ใบงานสลับกลับด้วย เนื่องจากมีการแก้ไขข้อมูลสถานะตู้สลับกลับ")
        return
      }
    }
    if (memoDataHasChange) {
      const memoText = memoData && memoData.length > 0 ?
        JSON.stringify(memoData.map(memo => ({
          IsPin: memo.IsPin,
          Memo: memo.Memo,
          MemTm: dayjs(memo.MemTm).format("YYYY-MM-DD HH:mm:ss"),
          ModAccId: memo.ModAccId,
        })))
        : null
      if (postData.jobOrdData) {

        postData.jobOrdData.ColValues = {
          ...postData.jobOrdData.ColValues,
          Memo: memoText
        }
      } else {
        postData.jobOrdData = {
          JobOrdId: joData.JobOrdId,
          ColValues: { Memo: memoText },
          LogRmk: "แก้ไข Memo"
        }
      }
    }

      // console.log("postData", postData)
      // return
    if (contStsHasChange || tagDataHasChange || joDataHasChange || memoDataHasChange || ptDataHasChange) {

      ax.post(jobOrderApiNm.updateJobOrderAllDetailV4, postData).then(value => {
        if (value.data) {
          onFinish && onFinish(value.data)
        }
      })
    }
    setDialogOpen(false)

  }, [joData, contStatusData, tagData, ax, lastFilter, memoData, onFinish, selectedId
    , setDialogOpen, ptDataTable, msData.driverObj])

  const handlePrintJobOrder = useCallback(() => {

    joData.ContStses = contStatusData.map(cs => ({ ...cs, ContStsNm: msData.containerStatusObj[cs.ContStsId].Name }))
    printJobOrder({
      printDataArr: [{
        jobOrderData: joData, shipmentData: joData.Shipment, jobOrdIds: [joData.JobOrdId],
        fName: user.FName
      }], msData
    })
  }, [joData, msData, user.FName, contStatusData])

  const handlePrintJobOrderWithBg = useCallback(() => {

    joData.ContStses = contStatusData.map(cs => ({ ...cs, ContStsNm: msData.containerStatusObj[cs.ContStsId].Name }))
    printJobOrder({
      printDataArr: [{
        jobOrderData: joData, shipmentData: joData.Shipment, jobOrdIds: [joData.JobOrdId],
        fName: user.FName
      }],
      msData,
      withBackground: true
    })
  }, [joData, msData, user.FName, contStatusData])



  const onPettyCashFinish = useCallback(() => {
    ax.post(jobOrderApiNm.getDailyJobAllDetailV4Finance, { JobOrdId: selectedId }).then(value => {
      if (value.data) {
        setPTDataTable(addIdForDataGrid(value.data.PTs, "PCTrnsId"))
        setPIDataTable(addIdForDataGrid(value.data.PIs, "PCItmId"))
        setXJODataTable(addIdForDataGrid(value.data.XJOs, "ExpJobOrdId"))
        setFilesData(value.data.Files || [])
      }
    })
  }, [ax, selectedId])


  useEffect(() => {
    const prevSts2DrvId = prevContStsDataRef.current.find(cs => cs.ContStsId === 2)?.DrvId || null
    const prevSts4DrvId = prevContStsDataRef.current.find(cs => cs.ContStsId === 4)?.DrvId || null
    const currSts2DrvId = contStatusData.find(cs => cs.ContStsId === 2)?.DrvId || null
    const currSts4DrvId = contStatusData.find(cs => cs.ContStsId === 4)?.DrvId || null
    if (prevSts2DrvId !== currSts2DrvId) {
      if (!currSts2DrvId) {
        setJOData(o => ({ ...o, Sts2POIId: null }))
        return
      }
      const poiid = msData.serverData.CompanyData.Sts2POIId
      if (poiid) {
        setJOData(o => ({ ...o, Sts2POIId: poiid }))
      }
    }
    if (prevSts4DrvId !== currSts4DrvId) {
      if (!currSts4DrvId) {
        setJOData(o => ({ ...o, Sts4POIId: null }))
        return
      }
      const poiid = msData.serverData.CompanyData.Sts4POIId
      if (poiid) {
        setJOData(o => ({ ...o, Sts4POIId: poiid }))
      }
    }
  }, [contStatusData, msData.serverData.CompanyData])

  useEffect(() => {
    checkContStatus({ contStatusData, joData, prevContStsData: prevContStsDataRef.current })
  }, [contStatusData, joData])

  useEffect(() => {
    if (dialogOpen) {
      ax.post(jobOrderApiNm.getDailyJobAllDetailV4, { JobOrdId: selectedId }).then(value => {
        if (value.data) {
          const contStses = value.data.ContStses
          oContStatusDataRef.current = msData.containerStatuses.filter(item => !item.IsHide).map(contStatus => {
            const foundData = contStses?.find(it => it.ContStsId === contStatus.ContStsId)
            return {
              ...contStatus,
              DrvId: foundData && foundData.DrvId,
              TukId: foundData && foundData.TukId,
              JobOrdId: selectedId,
              StsTm: foundData && foundData.StsTm,
              Rmk: foundData && foundData.Rmk,
              IsCmpt: foundData && foundData.IsCmpt
            }
          })
          oTagDataRef.current = value.data.Tags.map(item => ({ id: item.TagId, label: item.Name }))

          !value.data.Memo && (value.data.Memo = [])
          oMemoDataRef.current = value.data.Memo.map((item, index) => ({ ...item, id: index }))
          delete value.data.Memo
          oJODataRef.current = { ...value.data }
          oJODataRef.current.processDrvId = null

          oJODataRef.current.Shipment = {
            CusNm: oJODataRef.current.CusNm,
            JobNo: oJODataRef.current.JobNo,
            Bkg: oJODataRef.current.Bkg,
            Agnt: oJODataRef.current.Agnt,
            Port: oJODataRef.current.Port,
            Vssl: oJODataRef.current.Vssl,
            Voy: oJODataRef.current.Voy,
            ShpmTypId: oJODataRef.current.ShpmTypId,
            Job: {
              RcptNm: oJODataRef.current.RcptNm,
              RcptAddr: oJODataRef.current.RcptAddr,
              RcptTaxId: oJODataRef.current.RcptTaxId,
              RcptBrchNo: oJODataRef.current.RcptBrchNo,
              Name: oJODataRef.current.JobNm,
              CmdyTyp: oJODataRef.current.CmdyTyp
            }
          }
          oJODataRef.current.ShRtnPOIId = oJODataRef.current.Shore?.RtnPOIId
          oJODataRef.current.ShRtnPlc = oJODataRef.current.Shore?.RtnPlc || ""
          oJODataRef.current.ShVssl = oJODataRef.current.Shore?.Vssl || ""
          oJODataRef.current.ShVoy = oJODataRef.current.Shore?.Voy || ""
          setContStsData(oContStatusDataRef.current.map(item => ({ ...item })))
          prevContStsDataRef.current = oContStatusDataRef.current.map(item => ({ ...item }))
          setJOData({ ...oJODataRef.current })
          setMemoData(oMemoDataRef.current.map((item) => ({ ...item })))
          setTagData(oTagDataRef.current.map(item => ({ ...item })))
          setPTDataTable(addIdForDataGrid(value.data.PTs, "PCTrnsId"))
          setPIDataTable(addIdForDataGrid(value.data.PIs, "PCItmId"))
          setXJODataTable(addIdForDataGrid(value.data.XJOs, "ExpJobOrdId"))
          setFilesData(value.data.Files || [])
        }
      })
    } else {
      setTagData([])
      setJOData({ ...initPageData })
      setContStsData(msData.containerStatuses.map(item => ({ ...item })))
      setFilesData([])
      setPTDataTable([])
      setPIDataTable([])
      setXJODataTable([])
      setMemoData([])
      prevContStsDataRef.current = []
      oContStatusDataRef.current = []
    }
  }, [dialogOpen, selectedId, ax, msData.containerStatuses])

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth
      PaperProps={{
        style: {
          maxWidth: 1800
        }
      }}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={`ข้อมูลใบงานเลขที่ ${selectedId}`}
        onDeleteClick={() => deleteJobOrder(selectedId)}>
        <Box display="flex" gap={2} ml={2}>
          <Button variant="contained" color="success" onClick={() => setDialogHistoryOpen(true)}>
            <HistoryRounded sx={{ mr: 1 }} />ประวัติใบงาน
          </Button>
          <Button variant="contained" color="success" onClick={() => setDialogCSHistoryOpen(true)}>
            <HistoryRounded sx={{ mr: 1 }} />ประวัติจ่ายงาน
          </Button>
          {!joData.PrId &&
            <Button variant="contained" color="secondary" onClick={() => window.open(`${window.location.origin}/emily/AddJobOrderChild/${selectedId}`, "_blank")}>เพิ่ม/พิมพ์ใบงานย่อย</Button>
          }
          <ButtonGroupPopper mainButton={
            <Button variant="contained" color="secondary"
              onClick={handlePrintJobOrder} >
              พิมพ์ซ้ำใบงาน
            </Button>
          }
            arrowButtonStyle={{ variant: "contained", color: "secondary" }}>
            <Paper >
              <Button variant="outlined" size="small" color="secondary" onClick={handlePrintJobOrderWithBg}>พิมพ์พร้อมพื้นหลัง</Button>
            </Paper>
          </ButtonGroupPopper>
        </Box>
      </DialogHeader>
      <DialogContent sx={{ bgcolor: blueGrey[50], p: 1, height: 905 }}>
        <BoxFR pt={1} sx={{ alignItems: "stretch", height: "100%" }}>
          <BoxFC sx={{ gap: 1, height: "100%", width: 520 }}>
            <Paper sx={{ pt: 1, pb: 1, width: "100%", height: 130 }}>
              <BoxFR ml={2}>
                <Typography variant="h6">สถานะตู้</Typography>
              </BoxFR>
              <ContStatus contStatusData={contStatusData} joData={joData} />
            </Paper>

            <Paper sx={{ px: 2, pt: 1, pb: 2, width: "100%" }}>
              <BoxFC sx={{ gap: 1 }}>
                <Typography variant="h6" sx={{ width: "100%" }}>ข้อมูลใบแจ้งลาก</Typography>
                <Shipment joData={joData} msData={msData} />
              </BoxFC>
            </Paper>
            <Paper sx={{ px: 2, pt: 1, pb: 2, width: "100%", }}>
              <BoxFC sx={{ gap: 1 }}>
                <Typography variant="h6" sx={{ width: "100%" }}>ข้อมูลชอร์</Typography>
                <Shore joData={joData} msData={msData} />
              </BoxFC>
            </Paper>
            <Paper sx={{ p: 1, width: "100%" }}>
              <BoxFC sx={{ gap: 1 }} height={340} >
                <Memo memoData={memoData} setMemoData={setMemoData} dialogOpen={dialogOpen} msData={msData} />
              </BoxFC>
            </Paper>
          </BoxFC>
          <BoxFC sx={{ gap: 1 }}>
            <Paper sx={{ px: 2, pt: 1, flex: 1 }}>
              <BoxFC sx={{ gap: 1, height: "100%" }}>

                <JODataComponent
                  joData={joData}
                  setJOData={setJOData}
                  contStatusData={contStatusData}
                />
                <ContStsComponent
                  contStatusData={contStatusData}
                  setContStsData={setContStsData}
                  joData={joData}
                  setJOData={setJOData} />
                <BoxFR sx={{ alignItems: "stretch", flex: 1 }}>

                  <JODataExtraComponent joData={joData} setJOData={setJOData} tagData={tagData} setTagData={setTagData} />
                  <PCComponent
                    joData={joData}
                    setJoData={setJOData}
                    ptDataTable={ptDataTable}
                    setPTDataTable={setPTDataTable}
                    piDataTable={piDataTable}
                    onPettyCashFinish={onPettyCashFinish} />
                  <XJOComponent
                    xjoDataTable={xjoDataTable}
                    onPettyCashFinish={onPettyCashFinish}
                    jobOrdId={joData.JobOrdId} />
                </BoxFR>


              </BoxFC>
            </Paper>
            <Paper sx={{ px: 2, pt: 1, height: 170, maxWidth: 1260 }}>
              <FilePreviewComponent
                filesData={filesData}
                jobOrdId={joData.JobOrdId}
                joData={joData}
                onPettyCashDialogFinish={onPettyCashFinish} />
            </Paper>
          </BoxFC>

        </BoxFR >
      </DialogContent >
      <LogTableDialog
        tableName="job_order_log"
        idColNm="JobOrdId"
        idValue={selectedId}
        excludeKeys={excludeKeys}
        colNm={jobOrderColNm}
        title={`ประวัติการแก้ไขข้อมูลใบงานเลขที่ ${selectedId}`}
        dialogOpen={dialogHistoryOpen}
        setDialogOpen={setDialogHistoryOpen}
      />
      <LogViewDialog
        columns={jocsHistoryColumns}
        colNm={jobOrderColNm}
        width={jocsHistoryColumnsWidth}
        datetimeFormat={jocsHistoryDatetimeFormat}
        endpoint="/core/getTableLog"
        postData={jocsHistoryPostData}
        title={`ประวัติสถานะตู้ใบงานเลขที่ ${selectedId}`}
        dialogOpen={dialogCSHistoryOpen}
        setDialogOpen={setDialogCSHistoryOpen}
      />
      <DialogFooter okText="แก้ไขข้อมูล"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOK} />
    </Dialog >

  );
}

export default DailyJobDialogV3;
